import { render } from "./Dashboard5.vue?vue&type=template&id=6d716bd8"
import script from "./Dashboard5.vue?vue&type=script&lang=js"
export * from "./Dashboard5.vue?vue&type=script&lang=js"

import "./Dashboard5.vue?vue&type=style&index=0&id=6d716bd8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__